// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import type { HttpClientInstance } from '@toggl/sync/http';
import type {
  SubscriptionsFinishTrialRequest,
  SubscriptionsStartTrialRequest,
  SubscriptionsTrial,
} from '../types';

export async function postStartTrial(
  httpClient: HttpClientInstance,
  workspace_id: number,
  data: SubscriptionsStartTrialRequest,
  signal?: AbortSignal
) {
  const response = await httpClient
    .post(`workspaces/${workspace_id}/subscriptions/trials`, {
      signal,
      json: data,
    })
    .json<SubscriptionsTrial>();
  return response;
}

export async function postFinishTrial(
  httpClient: HttpClientInstance,
  workspace_id: number,
  trial_id: number,
  data: SubscriptionsFinishTrialRequest,
  signal?: AbortSignal
) {
  const response = await httpClient
    .post(
      `workspaces/${workspace_id}/subscriptions/trials/${trial_id}/finish`,
      { signal, json: data }
    )
    .json<unknown>();
  return response;
}
